import React, { useCallback } from 'react';
import { Text, Image, Pressable, StyleSheet, View } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../constants/styles';

const DOWN_ARROW_ICON = require('../../../resources/arrow-down.png');

function HeaderItem(props) {
  const { onPress, label, name, sortColumn, sortDir, style, left } = props;

  const handlePress = useCallback(() => {
    onPress?.(name);
  }, [onPress, name]);

  const activeColumn = sortColumn === name;
  return (
    <Pressable
      onPress={handlePress}
      style={[styles.headerButton, left ? styles.headerButtonLeft : null, style]}
      disabled={!onPress}
    >
      <Text style={[styles.headerText, activeColumn ? styles.headerTextSelected : null]}>
        {label}
      </Text>
      {!!onPress && (
        <View
          style={[
            styles.sortIconWrap,
            activeColumn && sortDir < 0
              ? {
                  transform: [{ rotate: '180deg' }],
                }
              : null,
          ]}
        >
          <Image
            source={DOWN_ARROW_ICON}
            style={[
              styles.sortIcon,
              {
                tintColor: activeColumn ? COLOR.callToAction : COLOR.text,
              },
            ]}
          />
        </View>
      )}
    </Pressable>
  );
}

const styles = StyleSheet.create({
  ...THEME,
  headerButton: {
    flexDirection: 'row',
    ...THEME.sectionHeaderColumn,
  },
  headerButtonLeft: {
    paddingLeft: 20,
  },
  headerText: {
    flex: 1,
    ...THEME.sectionHeaderText,
  },
  headerTextSelected: {
    ...FONT.semibold,
    color: COLOR.text,
  },
  sortIconWrap: {
    width: __WEB__ ? 50 : 40,
    alignSelf: 'stretch',
    justifyContent: 'center',
    alignItems: 'center',
  },
  sortIcon: {
    width: 10,
    height: 6,
  },
});

export default HeaderItem;
